var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSscRecursosV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 24,
    r: 7,
    fill: "#2563EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 24,
    r: 7,
    fill: "#2563EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 48c0-6 8-10 12-10s12 4 12 10",
    fill: "#93C5FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 48c0-6 8-10 12-10s12 4 12 10",
    fill: "#93C5FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSscRecursosV2);
export default __webpack_public_path__ + "static/media/ssc_recursos_v2.fe3ba13feb8146b88906e041fbf45d26.svg";
export { ForwardRef as ReactComponent };